import React, { forwardRef, RefObject } from 'react';

import { ScatterPlotProps } from './types';
import { StyledScatterPlot } from './styles';

export const LoadingScatterPlot = forwardRef<HTMLDivElement, ScatterPlotProps>(
  (props, ref) => {
    const { className, ...forwardedProps } = props;

    return (
      <StyledScatterPlot
        {...forwardedProps}
        className={className}
        ref={ref as RefObject<HTMLDivElement>}
      >
        Loading...
      </StyledScatterPlot>
    );
  }
);
